import { Information } from '../../common/texts';
import { HelpPopover } from '../HelpPopover';

export function TemperatureInformationIconPopover() {
  return (
    <HelpPopover
      tabIndex={0}
      headerText={'Temperature specification'}
      descriptionText={Information.Plugin}
    />
  );
}
